import React from 'react';
import {
  generateInvitePartnerLink,
  LocalizePropType,
  selectUser,
  setNotification,
  withTextLocalizer,
  truncateText,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import TariffPartnerView from './TariffPartnerView';
import { navigateTo } from '../../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '../../../../hooks/useQuery';

type Props = {
  localize: LocalizePropType;
};

const TariffPartnerContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const query = useQuery();

  const queryInviteLink = query.get('inviteLink');
  const [tariffPartnerEnabled, setTariffPartnerEnabled] = React.useState(
    !!queryInviteLink
  );
  const [inviteLink, setInviteLink] = React.useState(queryInviteLink || '');

  const onClose = () => {
    navigateTo(history, '/settings');
  };

  const onSwitchValueChange = (value: boolean) => {
    if (value) {
      dispatch(
        generateInvitePartnerLink(localize, history, (res) => {
          setInviteLink(res?.link);
          setTariffPartnerEnabled(value);
        })
      );
    }
  };

  const onClickShare = () => {
    if (inviteLink) {
      if (navigator.share) {
        navigator
          .share({
            title: localize('tariff.partner.share.title'),
            text: localize('tariff.partner.share.text'),
            url: inviteLink,
          })
          .catch((error) => console.error('Error sharing:', error));
      } else {
        try {
          navigator.clipboard.writeText(inviteLink);
          dispatch(
            setNotification({
              message: localize(
                'wj.value.copied',
                truncateText(inviteLink, 70)
              ),
            })
          );
          // eslint-disable-next-line no-empty
        } catch (error) {}
      }
    }
  };

  const onClickLink = () => {
    if (inviteLink) {
      try {
        navigator.clipboard.writeText(inviteLink);
        dispatch(
          setNotification({
            message: localize('wj.value.copied', truncateText(inviteLink, 70)),
          })
        );
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  };
  return (
    <TariffPartnerView
      localize={localize}
      onClose={onClose}
      inviteLink={inviteLink}
      tariffPartnerEnabled={tariffPartnerEnabled}
      onSwitchValueChange={onSwitchValueChange}
      onClickShare={onClickShare}
      onClickLink={onClickLink}
    />
  );
};

export default withTextLocalizer(TariffPartnerContainer);
